<div class="cart-title-section" fxLayoutAlign="space-between center">
    <div class="heading" translate><ng-content></ng-content></div>

</div>